module.exports = __webpack_public_path__ + "img/video-thumb-2-nl.35a116c6.png";